import { render, staticRenderFns } from "./AddOrEditItemDialogSubItem.vue?vue&type=template&id=3558bfcb&scoped=true"
import script from "./AddOrEditItemDialogSubItem.vue?vue&type=script&lang=js"
export * from "./AddOrEditItemDialogSubItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3558bfcb",
  null
  
)

export default component.exports